// @flow
export const UI = 'ui'
export const TABS = 'tabs'

export const IS_MAIN_MENU_OPEN = 'isMainMenuOpen'
export const IS_USER_MENU_OPEN = 'isUserMenuOpen'
export const IS_FILTERS_OPEN = 'isFiltersOpen'
export const IS_CURRENT_BIDS_OPEN = 'isCurrentBidsOpen'

export const CURRENT_FILTER = 'currentFilter'

export const TOGGLE_MAIN_MENU = 'TOGGLE_MAIN_MENU'
export const TOGGLE_USER_MENU = 'TOGGLE_USER_MENU'
export const TOGGLE_FILTERS = 'TOGGLE_FILTERS'
export const TOGGLE_CURRENT_BIDS = 'TOGGLE_CURRENT_BIDS'

export const SET_CURRENT_FILTER = 'SET_CURRENT_FILTER'
export const SET_TAB_INDEX = 'SET_TAB_INDEX'



// WEBPACK FOOTER //
// ./src/services/layout/constants.js